(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eg-langues"] && !Shopify.designMode) return;
  try {
    /* Menu des langues de l'en-tête (ordinateur) : bouton [data-eg-lg] (aria-expanded), liste de boutons d'envoi.
     Clic sur le bouton : ouvre / ferme (au clavier, le focus va sur la langue courante). Échap ferme et rend le focus au bouton ;
     clic ou focus ailleurs ferment. Flèches haut / bas, Début / Fin dans la liste. Le menu est rendu après l'en-tête :
     Tab depuis le bouton ouvert entre dans la liste, Maj+Tab depuis la première langue revient au bouton, Tab depuis la
     dernière ferme et passe à l'entrée suivante de l'en-tête.
     Clic sur une langue : envoi immédiat du formulaire Shopify (changement de langue). Langue courante : rien à envoyer, on ferme. */
  (function () {
    if (window.__egLangues) return;
    window.__egLangues = true;
    var d = document;
    function btn() { return d.getElementById('EgLgB'); }
    function panel() { return d.getElementById('EgLgP'); }
    function items() { var p = panel(); return p ? Array.prototype.slice.call(p.querySelectorAll('.eg-lg-i')) : []; }
    function isOpen() { var p = panel(); return !!(p && !p.hidden); }
    /* Position horizontale : centré sous le bouton, sans sortir de l'enveloppe de l'en-tête. */
    function place() {
      var b = btn(), p = panel();
      if (!b || !p || p.hidden) return;
      var wrap = p.offsetParent;
      if (!wrap) return;
      var x = 0, el = b;
      while (el && el !== wrap) { x += el.offsetLeft; el = el.offsetParent; }
      if (el !== wrap) return;
      var w = p.offsetWidth;
      var left = x + b.offsetWidth / 2 - w / 2;
      p.style.left = Math.max(0, Math.min(left, wrap.clientWidth - w)) + 'px';
    }
    function setOpen(open, focusBtn) {
      var b = btn(), p = panel();
      if (!b || !p) return;
      var was = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', String(open));
      p.hidden = !open;
      if (open) place();
      else if (was && (focusBtn || p.contains(d.activeElement))) b.focus();
    }
    function focusCurrent() {
      var l = items();
      var c = l.filter(function (x) { return x.getAttribute('aria-current') === 'true'; })[0] || l[0];
      if (c) c.focus();
    }
    /* Entrée de l'en-tête qui suit le bouton (ordre de tabulation). */
    function afterBtn(b) {
      var hd = d.getElementById('hd');
      if (!hd) return null;
      var all = Array.prototype.slice.call(hd.querySelectorAll('a[href], button:not([disabled])')).filter(function (x) { return x.offsetParent !== null; });
      var i = all.indexOf(b);
      return i >= 0 ? all[i + 1] || null : null;
    }
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var b = t.closest('[data-eg-lg]');
      if (b) {
        var open = b.getAttribute('aria-expanded') !== 'true';
        setOpen(open);
        if (open && e.detail === 0) focusCurrent();
        return;
      }
      var it = t.closest('.eg-lg-i');
      if (it) {
        if (it.getAttribute('aria-current') === 'true') { e.preventDefault(); if (isOpen()) setOpen(false, true); return; }
        if (it.form) it.form.classList.add('is-busy');
        return; /* envoi normal du formulaire localization */
      }
      var p = panel();
      if (p && !p.hidden && !p.contains(t)) setOpen(false);
    });
    d.addEventListener('keydown', function (e) {
      var b = btn();
      if (!b) return;
      var a = d.activeElement;
      if (!isOpen()) {
        if (a === b && e.key === 'ArrowDown') { e.preventDefault(); setOpen(true); focusCurrent(); }
        return;
      }
      var l = items();
      var i = l.indexOf(a);
      if (e.key === 'Escape') { e.preventDefault(); setOpen(false, true); return; }
      if (!l.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (a !== b && i < 0) return;
        e.preventDefault();
        var n;
        if (a === b) n = e.key === 'ArrowDown' ? 0 : l.length - 1;
        else n = e.key === 'ArrowDown' ? (i + 1) % l.length : (i - 1 + l.length) % l.length;
        l[n].focus();
        return;
      }
      if ((e.key === 'Home' || e.key === 'End') && i >= 0) { e.preventDefault(); l[e.key === 'Home' ? 0 : l.length - 1].focus(); return; }
      if (e.key !== 'Tab') return;
      if (!e.shiftKey && a === b) { e.preventDefault(); l[0].focus(); }
      else if (e.shiftKey && i === 0) { e.preventDefault(); b.focus(); }
      else if (!e.shiftKey && i === l.length - 1) {
        var nx = afterBtn(b);
        if (nx) { e.preventDefault(); setOpen(false); nx.focus(); }
      }
    });
    d.addEventListener('focusin', function (e) {
      var p = panel(), b = btn();
      if (p && !p.hidden && !p.contains(e.target) && e.target !== b) setOpen(false);
    });
    window.addEventListener('resize', function () {
      if (!isOpen()) return;
      if (window.innerWidth < 900) setOpen(false); else place();
    }, { passive: true });
    /* Retour arrière depuis le cache du navigateur : formulaires réactivés, menu fermé. */
    window.addEventListener('pageshow', function () {
      d.querySelectorAll('.eg-lg-f.is-busy, .eg-lg-ft.is-busy').forEach(function (f) { f.classList.remove('is-busy'); });
      if (isOpen()) setOpen(false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eg-promo"] && !Shopify.designMode) return;
  try {
    /* Offre de bienvenue −10 % : ouvre le formulaire Klaviyo indiqué par data-eg-p10.
     - Sans Klaviyo sur la page (intégration coupée) : l'entrée est masquée.
     - Inscription faite par ce formulaire (événement « klaviyoForms », type submit) : l'entrée est masquée et le restera
       dans ce navigateur (localStorage « eg-p10 », sous try/catch).
     - Si Klaviyo ne s'est pas chargé (bloqueur…) 2,5 s après le clic : message d'erreur (EG.toast). */
  (function () {
    if (window.__egP10) return;
    window.__egP10 = true;
    var d = document;
    var KEY = 'eg-p10';
    var vu = false;
    function boxes() { return d.querySelectorAll('[data-eg-p10-box]'); }
    function hideAll() { boxes().forEach(function (b) { b.hidden = true; }); }
    function fait() { try { return !!window.localStorage.getItem(KEY); } catch (e) { return false; } }
    function klaviyoPresent() {
      return !!(window._klOnsite || window.klaviyo || window._learnq || d.querySelector('script[src*="klaviyo"]'));
    }
    function ids() { return Array.prototype.map.call(d.querySelectorAll('[data-eg-p10]'), function (b) { return b.getAttribute('data-eg-p10'); }); }
    function start() {
      if (!boxes().length) return;
      if (fait() || !klaviyoPresent()) hideAll();
    }
    window.addEventListener('klaviyoForms', function (e) {
      vu = true;
      var x = (e && e.detail) || {};
      if (x.type === 'close') d.documentElement.classList.remove('eg-kl-ok');
      if (x.type === 'submit' && x.formId && ids().indexOf(String(x.formId)) >= 0) {
        try { window.localStorage.setItem(KEY, '1'); } catch (err) { /* stockage indisponible : masqué pour cette page seulement */ }
        hideAll();
      }
    });
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-eg-p10]');
      if (!b) return;
      e.preventDefault();
      var id = b.getAttribute('data-eg-p10');
      if (!id) return;
      window._klOnsite = window._klOnsite || [];
      d.documentElement.classList.add('eg-kl-ok');
      window._klOnsite.push(['openForm', id]);
      setTimeout(function () {
        if (vu || window.klaviyoModulesObject) return;
        var msg = b.getAttribute('data-l-err');
        if (msg && window.EG && typeof window.EG.toast === 'function') window.EG.toast(msg, null, true);
      }, 2500);
    });
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
